'use strict';

ColumnDefinitionPreprocessorFactory.$inject = [
	'mx.SolutionBuilderAgent.PersonalizationService',
	'mx.SolutionBuilderAgent.mxColumnDefinitionService',
	'$q',
	'mx.SolutionBuilderAgent.BasePreprocessor',
];
export default function ColumnDefinitionPreprocessorFactory(personalizationService, columnDefinitionService, $q, BasePreprocessor) {
	function ColumnDefinitionPreprocessor() {
		BasePreprocessor.apply(this);
		this.type = mx.SolutionBuilderAgent.PreprocessorType.ColumnDefinition;
		return this;
	}

	ColumnDefinitionPreprocessor.prototype = angular.extend(Object.create(BasePreprocessor.prototype), {
		build: function () {
			return this.executor.columnsBuild(this._columns);
		},

		load: async function (widgetId, dataQueryId, parameters) {
			const self = this;
			self.widgetId = widgetId;

			const personalColumns = await personalizationService.getGridPersonalization(widgetId);
			const dqColumns = parameters.dataQuery.Columns;

			const newColumns = {};

			const dataQueryHasVisibleColumn = function (columnName) {
				return dqColumns.some(function (dqColumn) {
					return dqColumn.Name === columnName && dqColumn.IsDisplay === true;
				});
			};

			for (let column in personalColumns) {
				if (personalColumns.hasOwnProperty(column) && dataQueryHasVisibleColumn(column)) {
					newColumns[column] = personalColumns[column];
				}
			}

			dqColumns.forEach(function (dqColumn) {
				if ((dqColumn.IsDisplay === true || dqColumn.IsLoading === true) && !personalColumns[dqColumn.Name]) {
					newColumns[dqColumn.Name] = { IsDisplay: true };
				}
			});

			self.allColumns = dqColumns;
			self._columns = newColumns;
		},

		callVisibilityChanged: function (column) {
			var self = this;

			personalizationService.savePersonalizedColumnVisibility(column, self.widgetId).then(function () {
				if (column.visible) {
					personalizationService.getGridPersonalization(self.widgetId).then(function (columns) {
						self._columns = columns;
						self.changed();
					});
				}
			});
		},

		callPositionChanged: function (column, oldPosition, newPosition, columns) {
			personalizationService.savePersonalizedColumnPosition(columns, this.widgetId);
		},

		callSizeChanged: function (column, columnWidthShift, absoluteWidth) {
			personalizationService.savePersonalizedColumnSize(column, absoluteWidth, this.widgetId);
		},
	});

	return ColumnDefinitionPreprocessor;
}
